import { OrdersPage } from 'pages/orders';

export const OrdersView = () => {
  return <OrdersPage />;
}
